







































































import Vue from 'vue';
import _ from 'lodash';

import moment from 'moment-timezone';
import Requester from '../../requester';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { ConsultaPostFormData, TipoConsulta } from '../../../../back/src/types';

import Confirmar from '../Confirmar.vue';

export default Vue.extend({
  name: 'TheConsultasAgendamentoIndividual',
  components: {
    Confirmar,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
      default: null,
    },
  },
  data() {
    return {
      loading: {
        submit: false,
      },
      menuDataAgendamento: false,
      form: {
        dataAgendamento: '',
        horarioAgendamento: '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório.',
        ],
        hora: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            const timePattern: RegExp = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
            return (v && timePattern.test(v)) || 'Horário inválido';
          },
        ],
      },
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    dataAgendamentoFormatada(): string {
      if (this.form.dataAgendamento) {
        const momentDataAgendamento = moment(this.form.dataAgendamento);
        if (momentDataAgendamento.isValid()) {
          return momentDataAgendamento.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    datetimeAgendamento(): Date {
      const momentDatetimeAgendamento = moment(`${this.form.dataAgendamento} ${this.form.horarioAgendamento}`);
      return momentDatetimeAgendamento.toDate();
    },
    formConsultaAgendar(): Vue & { validate: () => boolean, resetValidation: () => void } {
      return this.$refs.formConsultaAgendar as Vue & {
        validate: () => boolean,
        resetValidation: () => void,
      };
    },
  },
  methods: {
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading.submit = true;
      if (!this.formConsultaAgendar.validate()) {
        this.loading.submit = false;
        return;
      }
      const formData: ConsultaPostFormData = {
        tipo_consulta: TipoConsulta.P,
        paciente_id: this.paciente.id,
        gestacao_id: this.paciente.gestacao_atual ? this.paciente.gestacao_atual.id : null,
        datetime_agendamento: this.datetimeAgendamento,
      };
      try {
        const response = await Requester.consulta.criaConsulta(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('novaConsulta', response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados do atendimento salvos com sucesso!' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
